export default "__VITE_ASSET__BkbbFPe3__"